import styled, { css } from 'styled-components';

import { Props } from '.';

export const MenuWrapper = styled.ul<Pick<Props, 'selected'>>`
  position: relative;
  border: none;
  outline: inherit;
  display: block;
  width: 190px;
  margin: 0;
  padding: 0;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSize.B3};
  cursor: pointer;

  ${(props) => (props.selected ? Focused : UnFocused)}

  & > div > span {
    float: left;
    display: block;
  }

  #inner {
    transform: rotate(45deg);
    width: 38px;
    height: 38px;
    top: 6px;
    position: absolute;
    border-radius: 5px;
  }

  #outer {
    position: absolute;
    width: 52px;
    height: 52px;
    right: -29px;
  }

  #lower {
    width: 185px;
    height: 50px;
    position: relative;
    display: flex;
    margin-left: 20px;
    align-items: center;
  }

  & > svg {
    position: absolute;
    right: 4.5px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const Focused = css`
  background: ${({ theme }) => theme.colors.gray900};
  color: #fff;
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  #inner {
    background-color: ${({ theme }) => theme.colors.gray900};
  }
`;

const UnFocused = css`
  background: ${({ theme }) => theme.colors.white100};
  color: ${({ theme }) => theme.colors.gray700};

  #inner {
    background-color: ${({ theme }) => theme.colors.white100};
  }
`;
